import React from 'react'

import { BannerItem } from './NewBanner.types'
import { handleCarouselClick } from './NewBannerHelpers'
import style from './PromoBunner.module.scss'

const textLeadDefault = `
  Количество предложения ограничено. Срок действия акции
  до&nbsp;30.09.2024. ПАО &laquo;ПИК СЗ&raquo;. ОГРН 1027739137084.
  Юр. адрес: 123242, г. Москва, ул. Баррикадная, д.&nbsp;19,
  стр.&nbsp;1. Подробнее на&nbsp;pik.ru.&nbsp;
  <br class='for-desktop'> Проектные декларации проектов
  на&nbsp;наш.дом.рф
`

export default function PromoBanner({
  place,
  id,
  pageType,
  bannerData,
  textLeadLink,
  textLead = textLeadDefault,
  customClass,
}: {
  place: string | undefined
  id: string | undefined
  pageType: string
  bannerData: BannerItem
  textLeadLink: string
  textLead?: string
  customClass?: string[]
}) {
  return (
    <a
      href={bannerData.href}
      target='_blank'
      onClick={() => {
        handleCarouselClick(
          `${bannerData.name} ${bannerData.text}`,
          id,
          pageType,
          place
        )
      }}
      className={[style.NewBanner].join(' ')}
    >
      <div
        className={`${style.banner} ${
          customClass
            ? customClass.map((className: string) => style[className]).join(' ')
            : ''
        }`}
      >
        <div className={style.banner__price}>
          <div>
            <p
              className={style['banner__price-value']}
              dangerouslySetInnerHTML={{ __html: bannerData.name }}
            />
          </div>
          <div className={style['banner__decor-button']}>
            <svg
              width='25'
              height='42'
              viewBox='0 0 25 42'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M20.3072 1.0261C20.5112 0.18275 19.4292 -0.364925 18.8494 0.288187L0.20987 21.2843C-0.266863 21.8213 0.121094 22.6604 0.846127 22.6604H8.05325C8.59863 22.6604 9.00099 23.161 8.87484 23.6826L4.6928 40.9739C4.48883 41.8173 5.57083 42.3649 6.15064 41.7118L24.7901 20.7157C25.2669 20.1787 24.8789 19.3396 24.1539 19.3396H16.9467C16.4014 19.3396 15.999 18.839 16.1252 18.3174L20.3072 1.0261Z'
                fill='#FC4C02'
              />
            </svg>
            <span>Успеть</span>
          </div>
        </div>
        <div className={style.banner__info}>
          <div className={style['banner__info-btn-wrap']}>
            {/*<button className={style['banner__info-btn']}>*/}
            {/*  <img*/}
            {/*    className={style['banner__info-btn-icon']}*/}
            {/*    src={lightning}*/}
            {/*    alt=''*/}
            {/*  />*/}
            {/*  <p>до 31 августа</p>*/}
            {/*</button>*/}
          </div>
          <div className={style['banner__info-lead-wrap']}>
            <p
              className={style['banner__info-leadLink']}
              dangerouslySetInnerHTML={{ __html: textLeadLink }}
            ></p>
            <p
              className={style['banner__info-lead']}
              dangerouslySetInnerHTML={{ __html: textLead }}
            ></p>
          </div>
          <div className={style.banner__decor}>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='96'
              height='172'
              viewBox='0 0 96 172'
              fill='none'
            >
              <path
                d='M96 72.9785L53.6168 81.5105L78.4376 0L0 93.8712L38.9617 86.7191L3.00618 172L96 72.9785Z'
                fill='white'
              />
            </svg>
          </div>
        </div>
      </div>
    </a>
  )
}
